/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { BaseService, HttpResponse } from '../../service/base';
import { EventDataResultDTO } from '../../service/event_service';
import { DiagnosticDTO } from '../fleet_tab/service';

//-------------------------------------------------------------------------------------------------
// DTO Objects
//-------------------------------------------------------------------------------------------------
export interface MowerDTO {
    id: string;
    name: string;
    totalDistance: number;
    gradedDistance: number;
}

export interface MowingDTO {
    assetId: string;
    latitude: number;
    longitude: number;
    timestamp: number;
    input1: boolean;
    input2: boolean;
    input3: boolean;
    input4: boolean;
}

export interface MowingResultDTO {
    id: string;
    name: string;
    odometer: number;
}

export interface MowingDashboardDTO {
    totalKm: number;
}

export interface MowingEventDTO {
    assetId: string;
    eventId: string;
    geoJson: string;
    start: number;
    stop: number;
}

//-------------------------------------------------------------------------------------------------

/** Main service class that handles calls to the server and caches data
 * where it can.
 *
 */
export class MowingService extends BaseService {
    /** Call to get the grader information for a time period
     *
     * @param startUTC Start time for query
     * @param endUTC End time for query
     * @returns Promise with the requested info.
     */
    async getMowers(startUTC: number, endUTC: number): Promise<HttpResponse<DiagnosticDTO[]>> {
        const response = await this.get<DiagnosticDTO[]>(this.url + '/api/' + this.orgid + '/mower/info?start=' + startUTC + '&end=' + endUTC);
        return response;
    }

    async getDailyData(startUTC: number, endUTC: number) {
        const response = await this.get<EventDataResultDTO[]>(this.url + '/api/' + this.orgid + '/mower/dailydata?start=' + startUTC + '&end=' + endUTC);
        return response;
    }

    async getEvents(assetid: string, startUTC: number, endUTC: number) {
        const response = await this.get<MowingEventDTO[]>(this.url + '/api/' + this.orgid + '/event/mower?assetid=' + assetid + '&start=' + startUTC + '&end=' + endUTC);
        return response;
    }
}
